import axios from 'axios';
import { api } from '@/api';

const types = {
    SET_FAMILY_REPORTS: 'SET_FAMILY_REPORTS',
    FETCH_FAILURE: 'FETCH_FAILURE',
    SET_LOADING_STATUS: 'SET_LOADING_STATUS',

    SET_FAMILY: 'SET_FAMILY',
    SET_BABYSITTER: 'SET_BABYSITTER',

    SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
    SET_ITEMS_PER_PAGE: 'SET_ITEMS_PER_PAGE',
    SET_TOTAL_ITEMS: 'SET_TOTAL_ITEMS',
}

export const state = {
    reports: [],
    loading: false,

    // filters
    family: null,
    babysitter: null,

    currentPage: 1,
    itemsPerPage: 10,
    total: null,

}

export const mutations = {
    [types.SET_FAMILY_REPORTS]( state: any, data: any ) {
        state.reports = [];

        state.reports.push(...data.data);
        state.total = data.meta.total ? data.meta.total : 1;
    },
    [types.SET_LOADING_STATUS]( state: any, bool: boolean ) {
        state.loading = bool;
    },

    [types.SET_FAMILY]( state: any, data: string ) {
        state.family = data;
    },
    [types.SET_BABYSITTER]( state: any, data: string ) {
        state.babysitter = data;
    },

    [types.SET_CURRENT_PAGE]( state: any, data: number ) {
        state.currentPage = data;
    },

    [types.SET_ITEMS_PER_PAGE]( state: any, data: number ) {
        state.itemsPerPage = data;
    },
}

export const actions = { 
    async fetchFamilyReports({ commit, getters }: any, params: any) {
        try {
            commit(types.SET_LOADING_STATUS, true);
            let params = getters.payload;

            const { data } = await axios.get(api.path('v1.admin.familyReports'), { params: params });

            commit(types.SET_FAMILY_REPORTS, data);
            commit(types.SET_LOADING_STATUS, false);
            
        } catch (e) {
            commit(types.FETCH_FAILURE);
            commit(types.SET_LOADING_STATUS, false);
        }
    },

    clearPayload({ commit }: any, payload: any) {
        commit(types.SET_FAMILY, null);
        commit(types.SET_BABYSITTER, null);

        commit(types.SET_CURRENT_PAGE, 1);
        commit(types.SET_ITEMS_PER_PAGE, 10);
    },

    setFamilies({ commit }: any, payload: any) {
        commit(types.SET_FAMILY_REPORTS, payload); 
    },
    setFamiliesLoading({ commit }: any, payload: any) {
        commit(types.SET_LOADING_STATUS, payload); 
    },

    setFamily({ commit }: any, payload: any) {
        commit(types.SET_FAMILY, payload); 
    },
    setBabysitter({ commit }: any, payload: any) {
        commit(types.SET_BABYSITTER, payload); 
    },

    setCurrentPage({ commit }: any, payload: any) {
        commit(types.SET_CURRENT_PAGE, payload);
    },
    setItemsPerPage({ commit }: any, payload: any) {
        commit(types.SET_ITEMS_PER_PAGE, payload);
    },
}

export const getters = {
    reports: ( state: any ) => state.reports,
    familiesLoading: ( state: any ) => state.loading,
    total: ( state: any ) => state.total,

    family: ( state: any ) => state.family,
    babysitter: ( state: any ) => state.babysitter,

    currentPage: ( state: any ) => state.currentPage,
    itemsPerPage: ( state: any ) => state.itemsPerPage,

    payload: (state: any) => {
        return {
            family: state.family,
            babysitter: state.babysitter,

            page: state.currentPage,
            per_page: state.itemsPerPage
        }
    }
}